import React from 'react';
import * as LucideIcons from 'lucide-react';

import { useAppContext } from '../AppContext';
import withVisionAura from './visions/withVisionAura';

const ProfilePicture = withVisionAura(({ src, alt, onClick, className, userId }) => (
    <img src={src} alt={alt} onClick={onClick} className={className} />
));

const ConnectionCard = ({ profile, strength, onSelect }) => {
    const { onlineStatus } = useAppContext();
    const isOnline = onlineStatus[profile.id]?.state === 'online';

    const strengthColor = strength > 75 ? 'border-sky-400' : strength > 40 ? 'border-purple-400' : 'border-gray-600';

    return (
        <div onClick={onSelect} className={`connection-card ${strengthColor}`}>
            <div className="relative">
                <ProfilePicture src={profile.photoURL || "https://placehold.co/100x100/AEC6CF/FFFFFF?text=U"} alt={profile.displayName} className="w-20 h-20 rounded-full object-cover" userId={profile.id} />
                {isOnline && <span className="absolute bottom-0 right-0 w-4 h-4 bg-green-400 rounded-full border-2 border-gray-900" title="Online"></span>}
            </div>
            <p className="font-bold text-white truncate mt-2 text-sm">{profile.displayName}</p>
            <div className="w-full bg-gray-700 rounded-full h-1.5 mt-1">
                <div className="bg-gradient-to-r from-purple-500 to-sky-500 h-1.5 rounded-full" style={{ width: `${strength || 0}%` }}></div>
            </div>
        </div>
    );
};

export default ConnectionCard;
